import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  InputNumber,
  Row,
  Col,
  Select,
  Divider,
  useSelect,
  Button,
  Space,
  Spin,
  Icons,
  message,
} from '@pankod/refine-antd'
import type { RangePickerProps } from 'antd/es/date-picker'
import './style.css'
import { useCreateMany, useDelete, useDeleteMany, useGetIdentity, useList, useShow, useTable, useUpdate, useUpdateMany } from '@pankod/refine-core'
import 'styles/custom.css'
import {
  IGrade,
  ISubject,
  IWorkRequest,
  ITopic,
  IBloomLevel,
  ICentaStandard,
  IDifficultyLevel,
  IQuestion,
  IQuestionType,
  ITeacherLevel,
  IReportTheme,
  ITheme,
  ISubTheme,
  IAspect,
  IWorkRequestStatus,
  INotification,
  IWorkRequestReviewer,
  IWorkRequestApprover,
  ICompetency,
  IStrand,
  ITNTaxonomy,
  IWorkRequestGrades,
  IUser,
} from 'interfaces'
import sendEmail from 'sendmail'
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons'
import CompetencySelector from 'components/formelements/competencycascader'
import { SingleValueType } from 'rc-cascader/lib/Cascader'
import { useEffect, useState } from 'react'
import React from 'react'
import dayjs from 'dayjs'
import { DatePicker } from 'antd'
import { deleteWorkRequestGrades, getReportThemeBySubject, getReportThemeDataByTopicId } from 'gql/query'
import { createUserHistory, updateQuestionsAfterUserChange } from 'gql/mutations'
import { useUserContext } from 'context/user'
import { getWorkRequestStatusCount } from 'helpers'
import { useBloomsLevel, useCompetency, useDifficultyLevels, useGrades, useReportTheme, useSubjects } from 'utility/masterData'
type CreateWorkRequestProps = {
  modalProps: ModalProps
  formProps: FormProps
  record: any
  refreshData: any
  close: any
  updatePercentage: any
}
type AllReviewerData = {
  reviewer: object
  approver_ids: object[]
  ap_ids: string[]
  status: string
}
export const EditWorkRequest: React.FC<CreateWorkRequestProps> = ({ modalProps, formProps, record, refreshData, close, updatePercentage }) => {
  const { data: user } = useGetIdentity()
  const { userRole, qapproverList, qcreatorList, qreviewerList, vcreatorList } = useUserContext()
  let newApproverId = ''
  const [selectedValue, setSelectedValue] = useState<SingleValueType>([])
  const [defaultValue, setDefaultValue] = useState<SingleValueType>([])
  const [deleteApproverLoader, setDeleteApproverLoader] = useState(false)
  const [saveAsDraft, setSaveDraft] = useState(false)
  const [requestType, setRequestType] = useState('')
  const [questionQueryEnabled, setQuestionQueryEnabled] = useState(false)
  const [loadNewUsers, setLoadNewUsers] = useState(false)

  // const [newApproverId, setNewApproverId] = useState('')

  const [selectedReviewers, setSelectedReviewers] = useState<string[]>([])
  const [reviewers, setReviewers] = useState<object[]>([])
  const [selectedReviewerIds, setSelectedReviewerIDS] = useState<string[]>([])
  const [gradeDefaultValue, setGradeDefaultValue] = useState<string[]>([])
  const [selectedReviewersList, setSelectedReviewerList] = useState<string[]>([])
  const [selectedApproverIds, setSelectedApproverIDS] = useState<string[]>([])
  const [newAddedIds, setNewAddedIDS] = useState<number[]>([])
  const [allReviewers, setAllReviewers] = useState<object[]>([])
  const [totalVariantCount, setTotalVariantCount] = useState(0)
  const [questionCount, setQuestionCount] = useState(5)
  const [taxonomyfilter, setTaxonomyFilter] = useState([])
  const [strandfilter, setStrandFilter] = useState<any[]>([])
  const [showApprover, setShowApprover] = useState<boolean>(false)
  const [reloadApproverData, setReloadApproverData] = useState(false)
  const [reloadCreatorData, setResetCreatorData] = useState(false)
  const [reloadVCreatorData, setResetVCreatorData] = useState(false)
  const [showChangeUserSection, setShowChangeUserSection] = useState(false)
  const [selectedGrades, setSelectedGrades] = useState([] as any[])
  const [workRequestReviewers, setWorkRequestReviewers] = useState([] as any[])
  const [workRequestApprovers, setWorkRequestApprovers] = useState([] as any[])
  const [themeQueryEnabled, setThemeQueryEnabled] = useState<boolean>(false)
  const [subThemeQueryEnabled, setSubThemeQueryEnabled] = useState<boolean>(false)
  const [TopicQueryEnabled, setTopicQueryEnabled] = useState<boolean>(false)
  const [reportThemeQueryEnabled, setReportThemeQueryEnabled] = useState<boolean>(false)
  const [currentCreator, setCurrentCreator] = useState<IUser>()
  var notification_arr: object[] = []
  const [subjectFilter, setSubjectFilter] = useState<any[]>([])
  var mail_arr: object[] = []
  const [disableSaveBtn, setDisableSaveBtn] = useState(false)
  const [validation, setValidation] = useState({
    question_type_id: true,
    subject_id: true,
    creator_id: true,
  })
  // setShowChangeUserSection(!showChangeUserSection)
  const inputRef = React.useRef<HTMLButtonElement>(null)
  const { mutate } = useCreateMany<INotification>()
  const { mutate: createReviewers } = useCreateMany<IWorkRequestReviewer>()
  const { mutate: createApprovers } = useCreateMany<IWorkRequestApprover>()
  const { mutate: updateReviewers } = useDeleteMany<IWorkRequestReviewer>()
  const { mutate: updateApprovers } = useDeleteMany<IWorkRequestApprover>()
  const { mutate: createGrades } = useCreateMany<IWorkRequestGrades>()
  const { mutate: deleteGrades } = useDeleteMany<IWorkRequestGrades>()
  const { mutate: updateWorkRequest } = useUpdate<IWorkRequest>()
  const { mutate: updateWorkRequestReviewer } = useUpdate<IWorkRequestReviewer>()
  const { mutate: updateWorkRequestApprover } = useUpdate<IWorkRequestApprover>()
  const { mutate: removeReviewers } = useUpdateMany<IWorkRequestReviewer>()
  const { mutate: removeApprovers } = useUpdateMany<IWorkRequestApprover>()

  const { mutate: deleteApproverIds } = useDeleteMany<IWorkRequestApprover>()
  const { mutate: updateQuestionUsers } = useUpdateMany<IQuestion>()

  const gradeSelectProps = useGrades(modalProps?.visible)
  const bloomlevelSelectProps = useBloomsLevel(modalProps?.visible)
  const difficultylevelSelectProps = useDifficultyLevels(modalProps?.visible)
  const subjectSelectProps = useSubjects(modalProps?.visible)
  const competencySelectProps = useCompetency(modalProps?.visible)

  const onFinish = async (values: any) => {
    setDisableSaveBtn(true)
    selectedReviewerIds.filter((item: any, index: any) => selectedReviewerIds.indexOf(item) === index)
    let approverData: object[] = []
    let allApproverData: object[] = []
    allReviewers.map((item: any, i: any) => {
      delete values['approver_ids_' + i]
      delete values['reviwer_id_selected_' + i]

      if (selectedReviewerIds.includes(item?.reviewer?.id)) {
        item?.ap_ids.map((ids: any) => {
          allApproverData.push(ids)
        })
        approverData.push({ reviwer_id_selected: item?.reviewer?.id, approver_ids: item?.ap_ids })
      }
    })
    allApproverData = allApproverData.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })

    if (JSON.stringify(values?.reviewer_ids) !== '{}' && values?.reviewer_ids !== null && values?.reviewer_ids !== undefined) {
      values?.reviewer_ids.map((item: any) => {
        notification_arr.push({
          description:
            record?.status === 'Draft' && !saveAsDraft ? `work request ${values?.name} is Created` : `work request ${values?.name} is updated`,
          sender: user?.id,
          recepient: item,
          source_name: 'work_requests',
          title: 'New Task',
          redirect_id: record?.id,
          redirect_component: 'show',
          recepient_user_role: 'qreviewer',
        })
        let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === item)[0]
        mail_arr.push({
          subject: record?.status === 'Draft' && !saveAsDraft ? 'Work Request Created' : 'Work Request Updated',
          to: [{ name: reviewerDetails?.displayName, email: reviewerDetails?.email }],
          htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} is updated.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
        })
      })
    }
    if (approverData !== null && approverData !== undefined && approverData?.length > 0) {
      approverData?.map((item: any) => {
        item?.approver_ids.map((approver: any) => {
          notification_arr.push({
            description:
              record?.status === 'Draft' && !saveAsDraft ? `work request ${values?.name} is Created` : `work request ${values?.name} is updated`,
            sender: user?.id,
            recepient: approver,
            source_name: 'work_requests',
            title: 'New Task',
            redirect_id: record?.id,
            redirect_component: 'show',
            recepient_user_role: 'qapprover',
          })
          let approverDetails = qapproverList.filter((appUser: any) => appUser?.id === approver)[0]
          mail_arr.push({
            subject: record?.status === 'Draft' && !saveAsDraft ? 'Work Request Created' : 'Work Request Updated',
            to: [{ name: approverDetails?.displayName, email: approverDetails?.email }],
            htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} is updated.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
          })
        })
      })
    }
    if (values?.creator_id !== '' && values?.creator_id !== null && values?.creator_id !== undefined) {
      notification_arr.push({
        description:
          record?.status === 'Draft' && !saveAsDraft ? `work request ${values?.name} is Created` : `work request ${values?.name} is updated`,
        sender: user?.id,
        recepient: values?.creator_id,
        source_name: 'work_requests',
        title: 'New Task',
        redirect_id: record?.id,
        redirect_component: 'show',
        recepient_user_role: requestType === 'Q' ? 'qcreator' : 'variantcreator',
      })
      let creatorDetails = []
      if (requestType === 'Q') {
        creatorDetails = qcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }
      if (requestType === 'V') {
        creatorDetails = vcreatorList.filter((item: any) => item?.id === values?.creator_id)[0]
      }

      mail_arr.push({
        subject: record?.status === 'Draft' && !saveAsDraft ? 'Work Request Created' : 'Work Request Updated',
        to: [{ name: creatorDetails?.displayName, email: creatorDetails?.email }],
        htmlContent: `<html><body>Hi,<br/><h4> Work Request ${values?.name} is created by ${user?.displayName} is updated. You have to create ${values?.count} questions.For more information, Login to  <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
      })
    }
    let count = questionCount
    if (requestType === 'V') {
      count = 0
      values?.variant_options?.map((item: any) => {
        count = count + parseInt(item?.variant_count)
      })
    }
    formProps.form?.resetFields()
    setAllReviewers([])
    console.log(values,'values')
    values.topic_id = values.topic_id ? values.topic_id : null
    values.theme_id = values.theme_id ? values.theme_id : null
    values.sub_theme_id = values.sub_theme_id ? values.sub_theme_id : null
    values.competency_id = values.competency_id ? values.competency_id : null
    values.bloom_level_id = values.bloom_level_id ? values.bloom_level_id : null
    values.difficulty_level_id = values.difficulty_level_id ? values.difficulty_level_id : null

    if (values?.topic_id) {
      const topicId = values?.topic_id
      const reportThemeDetails: any = await getReportThemeDataByTopicId(topicId)
      //if report theme present then

      if (reportThemeDetails?.report_themes[0]?.id) {
        const reportThemeId = reportThemeDetails.report_themes[0].id
        values.report_theme_id = reportThemeId
      } else {
        values.report_theme_id = null
      }
    } else {
      values.report_theme_id = null
    }

    if (saveAsDraft === true) {
      setSaveDraft(false)
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          count: count,
          status: 'Draft',
          reviewer_ids: selectedReviewerIds,

          approver_ids: approverData,
          all_approver_ids: allApproverData,
          subject_id: values?.subject_id !== '' ? values?.subject_id : null,
          question_type_id: values?.question_type_id !== '' ? values?.question_type_id : null,
          creator_id: values?.creator_id !== '' ? values?.creator_id : null,
        })
      )
    } else {
      //added undefined to resolve the unexpected the loging outs
      values.old_creator_id = undefined
      return (
        formProps.onFinish &&
        formProps.onFinish({
          ...values,
          reviewer_ids: selectedReviewerIds,
          status: record?.status === 'Draft' ? 'Open' : record?.status,
          count: count,

          approver_ids: approverData,
          all_approver_ids: allApproverData,
        })
      )
    }
  }

  const { filters, setFilters, tableQueryResult, sorter } = useTable<ITopic>({
    resource: 'topics',
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    queryOptions: { enabled: TopicQueryEnabled && modalProps?.visible },
    metaData: { fields: ['id', 'name', 'sub_theme_id'] },
    initialPageSize: 1000,
  })
  const {
    filters: themeFilters,
    setFilters: setThemeFilters,
    tableQueryResult: themeResult,
  } = useTable<ITheme>({
    queryOptions: { enabled: themeQueryEnabled && modalProps?.visible },
    resource: 'themes',
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    initialPageSize: 1000,
    metaData: { fields: ['id', 'name', 'subject_id'] },
  })

  const {
    filters: subThemeFilters,
    setFilters: setSubThemeFilters,
    tableQueryResult: subThemeResult,
  } = useTable<ISubTheme>({
    queryOptions: { enabled: subThemeQueryEnabled && modalProps?.visible },
    resource: 'sub_themes',
    initialPageSize: 1000,
    permanentFilter: [
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    metaData: { fields: ['id', 'name', 'theme_id'] },
  })
  const {
    filters: questionFilter,
    setFilters: setQuestionFilters,
    tableQueryResult: questionResult,
  } = useTable<IQuestion>({
    queryOptions: {
      enabled: questionQueryEnabled && modalProps?.visible,
    },
    resource: 'questions',
    metaData: { fields: ['id', 'title'] },
    initialPageSize: 1000,
  })

  useEffect(() => {
    let creatorDetails = []
    if (record?.request_type === 'Q') {
      creatorDetails = qcreatorList.filter((item: any) => item?.id === record?.creator_id)?.[0]
    }
    if (record?.request_type === 'V') {
      creatorDetails = vcreatorList.filter((item: any) => item?.id === record?.creator_id)?.[0]
    }
    setCurrentCreator(creatorDetails)
  }, [record])
  useEffect(() => {
    let arr: object[] = []
    let reviewer_arr: object[] = []
    let approver_arr: object[] = []
    if (record?.workRequestGrades?.length > 0) {
      record?.workRequestGrades?.map((item: any) => {
        arr.push(item?.id)
      })
      arr = arr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })
      setSelectedGrades(arr)
    }
    if (record?.workRequestReviewers?.length > 0) {
      record?.workRequestReviewers?.map((item: any) => {
        reviewer_arr.push(item?.id)
      })
      reviewer_arr = reviewer_arr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })
      setWorkRequestReviewers(reviewer_arr)
    }

    if (record?.workRequestApprovers?.length > 0) {
      record?.workRequestApprovers?.map((item: any) => {
        approver_arr.push(item?.id)
      })
      approver_arr = approver_arr.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })
      setWorkRequestApprovers(approver_arr)
    }
  }, [record])

  useEffect(() => {
    setSaveDraft(false)
    setValidation({
      question_type_id: true,
      subject_id: true,
      creator_id: true,
    })

    setQuestionFilters([
      {
        field: 'subject_id',
        operator: 'eq',
        value: record?.subject_id,
      },
    ])
    setThemeFilters([
      {
        field: 'report_theme_id',
        operator: 'eq',
        value: record?.report_theme_id,
      },
    ])
    setQuestionQueryEnabled(true)
    setThemeQueryEnabled(true)
  }, [record])
  useEffect(() => {
    if (record?.subject_id) {
      let data: any = [
        {
          field: 'subject_id',
          operator: 'eq',
          value: record?.subject_id,
        },
      ]
      setSubjectFilter(data)
      setReportThemeQueryEnabled(true)
    }
  }, [record])
  useEffect(() => {
    if (record?.theme_id !== '' || record?.theme_id !== null) {
      subThemeFilters.pop()
      setSubThemeFilters([
        {
          field: 'theme_id',
          operator: 'eq',
          value: record?.theme_id,
        },
      ])
      setSubThemeQueryEnabled(true)
    }
  }, [record])
  useEffect(() => {
    if (record?.sub_theme_id !== '' || record?.sub_theme_id !== null) {
      filters.push({
        field: 'sub_theme_id',
        operator: 'eq',
        value: record?.sub_theme_id,
      })
      setFilters(filters)
      setTopicQueryEnabled(true)
    }
  }, [record])

  useEffect(() => {
    setRequestType(record?.request_type)
    if (record?.request_type === 'Q') {
      setQuestionCount(record?.count)
    } else {
      setTotalVariantCount(record?.count)
    }
  }, [record])
  const handleRequestType = (value: any) => {
    setRequestType(value)
    formProps?.form?.setFieldsValue({
      creator_id: null,
    })
  }
  // const handleReportThemeChange = (value: { value: any }) => {
  //   themeFilters.pop()
  //   formProps?.form?.setFieldsValue({
  //     sub_theme_id: null,
  //     topic_id: null,
  //     theme_id: null,
  //     questionResult: null,
  //   })
  //   setThemeFilters([
  //     {
  //       field: 'report_theme_id',
  //       operator: 'eq',
  //       value: value,
  //     },
  //   ])
  // }
  const handleSubjectChange = (value: { value: any }) => {
    setSubjectFilter([])
    formProps?.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
      theme_id: null,
      questionResult: null,
      report_theme_id: null,
    })
    themeFilters.pop()
    questionFilter.pop()
    let data: any = [
      {
        field: 'subject_id',
        operator: 'eq',
        value: value,
      },
    ]
    setThemeFilters(data)
    setSubjectFilter(data)
    setQuestionFilters(data)
  }
  const handleThemeChange = (value: { value: any }) => {
    formProps.form?.setFieldsValue({
      sub_theme_id: null,
      topic_id: null,
    })
    subThemeFilters.pop()
    setSubThemeFilters([
      {
        field: 'theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  const handleSubThemeChange = (value: { value: any }) => {
    formProps.form?.setFieldsValue({
      topic_id: null,
    })
    filters.pop()
    setFilters([
      {
        field: 'sub_theme_id',
        operator: 'eq',
        value: value,
      },
    ])
  }
  useEffect(() => {
    let arr: AllReviewerData[] = []
    let ids: string[] = []
    let r_arr: object[] = []
    let appr_list: any[] = []
    let ap_ids: any[] = []
    // alert(1)

    if (record?.workRequestApprovers?.length > 0) {
      // alert(2)
      record?.workRequestApprovers?.map((item: any) => {
        ap_ids = []
        appr_list = []
        ap_ids.push(item?.approver_id)
        let found = arr.findIndex((reviewer: any) => reviewer?.reviewer?.id === item?.reviewer_id)
        if (found === -1) {
          ids.push(item?.reviewer_id)
          const result1 = qapproverList?.filter((list: any) => list?.id === item?.approver_id)[0]
          appr_list.push(result1)

          const result = qreviewerList?.filter((list: any) => list?.id === item?.reviewer_id)[0]

          arr.push({ reviewer: result, approver_ids: appr_list, ap_ids: ap_ids, status: 'old' })
          r_arr.push(result)
        } else {
          ap_ids = []
          appr_list = []
          // let approver_ids=[]
          // approver_ids.push(item?.approver_id)
          const result1 = qapproverList?.filter((list: any) => list?.id === item?.approver_id)[0]
          appr_list.push(result1)
          arr[found]['approver_ids']?.push(result1)
          arr[found]['ap_ids']?.push(item?.approver_id)
          arr[found]['status'] = 'old'

          // arr.push({ reviewer: result, approver_ids: appr_list, ap_ids: ap_ids, status: 'old' })

          // arr[found]
        }
        // console.log("found approver", ids, item)
      })
    }

    if (record?.workRequestReviewers?.length > 0) {
      // alert(3)
      record?.workRequestReviewers?.map((item: any) => {
        let found = arr.findIndex((reviewer: any) => reviewer?.reviewer?.id === item?.user_id)
        ap_ids = []
        appr_list = []

        if (found === -1) {
          arr.push({ reviewer: item?.userByReviewerId, approver_ids: [], ap_ids: [], status: 'old' })
          ids.push(item?.user_id)
        }

        r_arr.push(item?.userByReviewerId)
        // const result = qreviewerList?.filter((list: any) => list?.user?.id === item)[0]?.user
      })
    }
    ids = ids.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })

    setSelectedReviewerIDS(ids)

    setAllReviewers(arr)
    if (record?.workRequestApprovers?.length > 0 || record?.workRequestApprovers?.length > 0) {
      setShowApprover(true)
    }
    setReviewers(arr)

    // setSelectedReviewerList(ids)
  }, [qapproverList, qreviewerList, record?.workRequestApprovers, record?.workRequestReviewers])
  const filterOptions = () => {
    let ids: string[] = []
    formProps?.form?.getFieldValue('approver_ids')?.map((item: any) => {
      ids.push(item?.reviwer_id_selected)
    })
    ids = ids.filter(function (item, index, inputArray) {
      return inputArray.indexOf(item) == index
    })
    setSelectedReviewerList(ids)
  }

  const { selectProps: tntaxonomySelectProps } = useSelect<ITNTaxonomy>({
    resource: 'tn_taxonomys',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [
      ...(taxonomyfilter ?? []),
      {
        field: 'in_use',
        operator: 'eq',
        value: true,
      },
    ],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const { selectProps: strandSelectProps } = useSelect<IStrand>({
    resource: 'strands',
    fetchSize: 100,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name', 'teacher_level_id', 'taxonomy_id', 'competency_id'],
    },
    sort: [{ field: 'name', order: 'asc' }],
    filters: [...(strandfilter ?? []), { field: 'in_use', operator: 'eq', value: true }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })

  const handleCompetencyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      taxonomy_id: null,
      teacher_level_id: null,
      strand_id: null,
    })
    let data: any = [
      {
        field: 'competency_id',
        operator: 'eq',
        value: value,
      },
    ]
    setTaxonomyFilter(data)
    setStrandFilter(data)
  }
  const handleTaxonomyChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      teacher_level_id: null,
      strand_id: null,
    })
    // let arr: any[] = [...strandfilter]
    // let data: any = {
    //   field: 'taxonomy_id',
    //   operator: 'eq',
    //   value: value,
    // }
    // arr.push(data)
    // setStrandFilter(arr)
    const updatedFilters = strandfilter.filter(filter => filter.field !== 'taxonomy_id')
    updatedFilters.push({
      field: 'taxonomy_id',
      operator: 'eq',
      value: value,
    })
    setStrandFilter(updatedFilters)
  }

  const handleTeacherLevelChange = (value: { value: any }) => {
    formProps?.form?.setFieldsValue({
      strand_id: null,
    })
    let arr: any[] = [...strandfilter]
    let data: any = {
      field: 'teacher_level_id',
      operator: 'eq',
      value: value,
    }

    arr.push(data)
    setStrandFilter(arr)
  }
  useEffect(() => {
    let arr: any[] = [...strandfilter]
    if (record?.comptency_id !== '' && record?.comptency_id !== null && record?.comptency_id !== undefined) {
      let data: any = [
        {
          field: 'competency_id',
          operator: 'eq',
          value: record?.comptency_id,
        },
      ]
      setTaxonomyFilter(data)
      // setStrandFilter(data)
    }
    if (record?.taxonomy_id !== '' && record?.taxonomy_id !== null && record?.taxonomy_id !== undefined) {
      let data: any = {
        field: 'taxonomy_id',
        operator: 'eq',
        value: record?.taxonomy_id,
      }
      arr.push(data)
      // setStrandFilter(arr)
    }
    if (record?.teacher_level_id !== '' && record?.teacher_level_id !== null && record?.teacher_level_id !== undefined) {
      let data: any = {
        field: 'teacher_level_id',
        operator: 'eq',
        value: record?.teacher_level_id,
      }
      arr.push(data)
    }
    setStrandFilter(arr)
  }, [record])
  // const getValueToRemove = () => {
  //   if (removedReviewerIds.length > 0) {
  //     let result: number[] = field_arr.filter((x: any) => !removedReviewerIds.includes(x))
  //     return result[0]
  //   } else return -1
  //   //   field_arr.filter((x: any) => !removedReviewerIds.includes(x))
  //   // }
  // }
  const addApprover = () => {
    setShowApprover(true)
  }
  const reviewerChange = (value: string[]) => {
    let arr: object[] = []
    let ids: string[] = []
    let all_data: object[] = [...allReviewers]
    let new_data: object[] = []

    if (value?.length > 0) {
      for (let i = 0; i < value?.length; i++) {
        const result1 = qreviewerList?.filter((item: any) => item?.id === value[i])[0]
        arr.push(result1)
        ids.push(value[i])
      }

      if (value?.length > selectedReviewerIds?.length) {
        let result_data = ids.filter(e => !allReviewers.find((item: any) => e == item.reviewer?.id))
        const data = qreviewerList?.filter((list: any) => list?.id === result_data[0])[0]

        all_data.push({ reviewer: data, approver_ids: [], ap_ids: [] })
      }
      if (value.length < selectedReviewerIds?.length) {
        all_data = all_data.filter((item: any) => ids.includes(item?.reviewer?.id))
      }
      ids = ids.filter(function (item, index, inputArray) {
        return inputArray.indexOf(item) == index
      })

      setAllReviewers(all_data)
      setSelectedReviewerIDS(ids)
    } else {
      setAllReviewers([])
      setSelectedReviewerIDS([])
    }
  }
  const changeApprover = (value: string[], rid: string) => {
    allReviewers.map((item: any, index: any) => {
      if (item?.reviewer?.id === rid) {
        let app_data: object[] = []
        let app_ids: string[] = []
        if (app_ids === undefined) {
          app_ids = []
        }
        for (let i = 0; i < value?.length; i++) {
          app_data.push(qapproverList?.filter((list: any) => list?.id === value[i])[0])

          app_ids.push(qapproverList?.filter((list: any) => list?.id === value[i])[0]?.id)
          app_data = app_data.filter((thing: any, index: any, self: any) => index === self.findIndex((t: any) => t.id === thing.id))
          app_ids = app_ids.filter(function (item, index, inputArray) {
            return inputArray.indexOf(item) == index
          })
        }
        item['approver_ids'] = app_data
        item['ap_ids'] = app_ids
        item['status'] = 'new'
        setSelectedApproverIDS(app_ids)
      }
    })
  }
  // eslint-disable-next-line arrow-body-style
  const disabledDate: RangePickerProps['disabledDate'] = current => {
    // Can not select days before today and today
    return current && current < dayjs()
  }
  const reportThemeSelectProps = useReportTheme(modalProps?.visible, subjectFilter)
  // const { selectProps: reportThemeSelectProps } = useSelect<IReportTheme>({
  //   resource: 'report_themes',
  //   defaultValueQueryOptions:{enabled:reportThemeQueryEnabled},
  //   fetchSize: 1000,
  //   optionLabel: 'name',
  //   optionValue: 'id',
  //   metaData: {
  //     fields: ['id', 'name'],
  //   },
  //   filters: subjectFilter,
  //   sort: [{ field: 'name', order: 'asc' }],
  //   onSearch: value => [
  //     {
  //       field: 'name',
  //       operator: 'contains',
  //       value: `${value.toLowerCase()}%`,
  //     },
  //   ],
  // })
  useEffect(() => {
    let value = record?.grade_ids === null ? [] : record?.grade_ids?.length > 0 ? record?.grade_ids : []
    // console.log('recordxxxx', value)
    setGradeDefaultValue(value)
  }, [record])
  const changeCreatorUser = (old: any) => {
    setLoadNewUsers(true)
    let creator_question_arr: any[] = []
    const new_creator = formProps?.form?.getFieldValue('new_creator_id')
    record?.questions?.map((item: any) => {
      if (item?.creator_id === old) {
        creator_question_arr?.push(item?.id)
      }
    })
    updateWorkRequest({
      resource: 'work_requests',
      values: {
        creator_id: new_creator,
      },
      id: record?.id,
    })
    updateQuestionUsers({
      resource: 'questions',
      values: {
        creator_id: new_creator,
      },
      ids: creator_question_arr,
    })
    notification_arr = []
    notification_arr.push({
      description: record?.status === 'Draft' && !saveAsDraft ? `work request ${record?.name} is Created` : `work request ${record?.name} is updated`,
      sender: user?.id,
      recepient: new_creator,
      source_name: 'work_requests',
      title: 'New Task',
      redirect_id: record?.id,
      redirect_component: 'show',
      recepient_user_role: 'qreviewer',
    })
    let creatorDetails = qcreatorList.filter((creators: any) => creators?.id === new_creator)[0]
    mail_arr.push({
      subject: 'Work Request Created and assigned to you',
      to: [{ name: creatorDetails?.displayName, email: creatorDetails?.email }],
      htmlContent: `<html><body>Hi,<br/><h4> Work Request ${record?.name} is created by ${user?.displayName} and assigned to you.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
    })

    setLoadNewUsers(false)
  }
  const changeApproverUsers = (old_approver: any, index: any) => {
    setLoadNewUsers(true)
    // let wr_approver_ids: object[] = []
    let approver_new_selectd_rev: object[] = []
    let new_approver_list: object[] = []
    let approver_question_arr: any[] = []
    const new_approver = formProps?.form?.getFieldValue('new_approver_id_' + index)
    const wr_approver_id = record?.workRequestApprovers?.filter((item: any) => item?.approver_id === old_approver)[0]
    let wr_approver_ids = record?.all_approver_ids
    const select_index = wr_approver_ids.indexOf(old_approver)
    wr_approver_ids[select_index] = new_approver
    record?.approver_ids?.map((item: any) => {
      // console.log({ item })
      item?.approver_ids?.map((approver: any) => {
        // console.log({ approver })
        new_approver_list = []
        if (approver === old_approver) {
          new_approver_list?.push(new_approver)
        } else {
          new_approver_list?.push(approver)
        }
        // console.log({ new_approver_list })
        approver_new_selectd_rev?.push({
          approver_ids: new_approver_list,
          reviwer_id_selected: item?.reviwer_id_selected,
        })
      })
    })
    record?.questions?.map((item: any) => {
      if (item?.approver_id === old_approver) {
        approver_question_arr?.push(item?.id)
      }
    })
    // console.log({ approver_new_selectd_rev, record });
    updateWorkRequest({
      resource: 'work_requests',
      values: {
        all_approver_ids: wr_approver_ids,
        approver_ids: approver_new_selectd_rev,
      },
      id: record?.id,
    })
    updateWorkRequestApprover({
      resource: 'work_request_approvers',
      values: {
        approver_id: new_approver,
      },
      id: wr_approver_id?.id,
    })
    updateQuestionUsers({
      resource: 'questions',
      values: {
        approver_id: new_approver,
      },
      ids: approver_question_arr,
    })
    let approverDetails = qapproverList.filter((approvers: any) => approvers?.id === new_approver)[0]
    mail_arr.push({
      subject: 'Work Request Created and assigned to you',
      to: [{ name: approverDetails?.displayName, email: approverDetails?.email }],
      htmlContent: `<html><body>Hi,<br/><h4> Work Request ${record?.name} is created by ${user?.displayName} and assigned to you. Questions to approve will assign shortly.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
    })
    notification_arr = []
    notification_arr.push({
      description: record?.status === 'Draft' && !saveAsDraft ? `work request ${record?.name} is Created` : `work request ${record?.name} is updated`,
      sender: user?.id,
      recepient: new_approver,
      source_name: 'work_requests',
      title: 'New Task',
      redirect_id: record?.id,
      redirect_component: 'show',
      recepient_user_role: 'qreviewer',
    })
    setLoadNewUsers(false)
  }

  const updateQuestions = async (key: string, old_value: string, new_value: string) => {
    await updateQuestionsAfterUserChange(key, old_value, new_value, record?.id).then((resp: any) => {})
  }

  const deleteApprover = async (approver: any, reviewer_details: any) => {
    setDeleteApproverLoader(true)

    let approverId = ''
    if (reviewer_details?.ap_ids?.length > 0) {
      const { for_approval_count, approved_count, rejected_count, retired_count } = getWorkRequestStatusCount(record)
      const approverIndex = (for_approval_count + approved_count + rejected_count + retired_count) % reviewer_details?.ap_ids?.length

      approverId = reviewer_details?.ap_ids[approverIndex]
    }

    newApproverId = approverId
    // setNewApproverId(approverId)
    // alert(1)
    let all_ids = record?.all_approver_ids
    var index = all_ids.indexOf(approver?.id)
    if (index !== -1) {
      all_ids.splice(index, 1)
    }

    let approver_ids = record?.approver_ids
    const updatedData = approver_ids.map((item: any) => {
      let found = item?.approver_ids?.findIndex((elem: any) => elem === approver?.id)
      if (found !== -1) {
        let data = item?.approver_ids
        data[found] = approverId
        data = data.filter(function (item: any, index: any) {
          return data.indexOf(item) === index
        })

        return {
          ...item,
          approver_ids: data,
        }
      } else {
        return item
      }
      // if (item?.approver_ids?.include(approver_id)) {

      // }
    })

    let newApproverIds: string[] = []
    record?.workRequestApprovers?.forEach((item: any) => {
      if (item.approver_id === approver?.id) {
        newApproverIds?.push(item?.id)
      }
    })

    deleteApproverIds({
      resource: 'work_request_approvers',
      ids: newApproverIds,
      invalidates: ['list', 'many', 'detail'],
      //    successNotification: (data, values, resource) => {

      //

      // },
    })

    return (
      formProps.onFinish &&
      formProps.onFinish({
        all_approver_ids: all_ids,
        approver_ids: updatedData,
      })
    )
  }
  const deleteReviewer = async (reviewer_id: string) => {
    setDeleteApproverLoader(true)
    let all_ids = selectedReviewerIds
    let reviewerId = ''
    var index = all_ids.indexOf(reviewer_id)
    if (index !== -1) {
      all_ids.splice(index, 1)
    }
    let workRequestReviewers: object[] = record?.workRequestReviewers
    let workRequestApprovers: object[] = record?.workRequestApprovers

    const { for_review_count, reviewed_count, approved_count, for_approval_count, rejected_count, retired_count } = getWorkRequestStatusCount(record)
    const reviewerIndex =
      (for_review_count + reviewed_count + rejected_count + retired_count + approved_count + for_approval_count) % reviewers?.length
    // console.log('reviewerIndex', reviewerIndex)
    reviewerId = all_ids[reviewerIndex]
    let newApproverIds: string[] = []
    workRequestApprovers?.forEach((item: any) => {
      if (item.reviewer_id === reviewer_id) {
        newApproverIds?.push(item?.id)
      }
    })
    let newWRReviewers: string[] = []
    workRequestReviewers?.forEach((element: any) => {
      newWRReviewers?.push(element?.id)
    })

    removeReviewers({
      resource: 'work_request_reviewers',
      values: {
        user_id: reviewerId,
      },
      ids: newWRReviewers,
      invalidates: ['list', 'many', 'detail'],
    })
    removeApprovers({
      resource: 'work_request_approvers',
      values: {
        reviewer_id: reviewerId,
      },

      ids: newApproverIds,
      invalidates: ['list', 'many', 'detail'],
    })
    updateQuestions('reviewer_id', reviewer_id, reviewerId)
    return (
      formProps.onFinish &&
      formProps.onFinish({
        reviewer_ids: all_ids,
      })
    )
  }
  const changeReviewerUsers = (old_reviewer: any, index: any) => {
    setLoadNewUsers(true)
    let approver_new_selectd_rev: object[] = []
    let reviewer_question_arr: any[] = []
    // const old_reviewer = formProps?.form?.getFieldValue('old_reviewer_id_' + index)
    const new_reviewer = formProps?.form?.getFieldValue('new_reviewer_id_' + index)
    // console.log("nmnmnm", record);
    let selected_rev_ids = record?.reviewer_ids
    const select_index = selected_rev_ids.indexOf(old_reviewer)
    selected_rev_ids[select_index] = new_reviewer
    const wr_revi_id = record?.workRequestReviewers?.filter((item: any) => item?.user_id === old_reviewer)[0]
    const wr_approver_id = record?.workRequestApprovers?.filter((item: any) => item?.reviewer_id === old_reviewer)[0]

    record?.approver_ids?.map((item: any) => {
      if (item?.reviwer_id_selected === old_reviewer) {
        approver_new_selectd_rev?.push({
          approver_ids: item?.approver_ids,
          reviwer_id_selected: new_reviewer,
        })
      } else {
        approver_new_selectd_rev?.push(item)
      }
    })
    record?.questions?.map((item: any) => {
      if (item?.reviewer_id === old_reviewer) {
        reviewer_question_arr?.push(item?.id)
      }
    })
    // const wr_apprv_selected_rev = record?.approver_ids?.filter((item: any) => item?.user_id === old_reviewer)[0]
    updateWorkRequest({
      resource: 'work_requests',
      values: {
        reviewer_ids: selected_rev_ids,
        approver_ids: approver_new_selectd_rev,
      },
      id: record?.id,
    })
    updateWorkRequestReviewer({
      resource: 'work_request_reviewers',
      values: {
        user_id: new_reviewer,
      },
      id: wr_revi_id?.id,
    })
    if (wr_approver_id) {
      updateWorkRequestApprover({
        resource: 'work_request_approvers',
        values: {
          reviewer_id: new_reviewer,
        },
        id: wr_approver_id?.id,
      })
    }
    updateQuestionUsers({
      resource: 'questions',
      values: {
        reviewer_id: new_reviewer,
      },
      ids: reviewer_question_arr,
    })
    notification_arr = []
    notification_arr.push({
      description: record?.status === 'Draft' && !saveAsDraft ? `work request ${record?.name} is Created` : `work request ${record?.name} is updated`,
      sender: user?.id,
      recepient: new_reviewer,
      source_name: 'work_requests',
      title: 'New Task',
      redirect_id: record?.id,
      redirect_component: 'show',
      recepient_user_role: 'qreviewer',
    })
    let reviewerDetails = qreviewerList.filter((reviewers: any) => reviewers?.id === new_reviewer)[0]
    mail_arr.push({
      subject: 'Work Request Created and assigned to you',
      to: [{ name: reviewerDetails?.displayName, email: reviewerDetails?.email }],
      htmlContent: `<html><body>Hi,<br/><h4> Work Request ${record?.name} is created by ${user?.displayName} and assigned to you. Questions to review will assign shortly.For more information, Login to <a href="${process.env.REACT_APP_PRODUCTION_URL}" target='_blank'>centa ams</a> .</h4></body></html>`,
    })
    setLoadNewUsers(false)

    // console.log("nmnmnm", approver_new_selectd_rev, record);
  }
  const [messageApi, contextHolder] = message.useMessage()
  const showMessage = (type: any) => {
    messageApi.open({
      type: type,
      content: 'This is a prompt message with custom className and style',
      className: 'custom-class',
      style: {
        marginTop: '20vh',
      },
    })
  }
  return (
    <Modal {...modalProps} title="Edit Work Request" okButtonProps={{ hidden: true }} cancelButtonProps={{ hidden: true }}>
      <Form
        {...formProps}
        layout="vertical"
        onFinish={async values => {
          let response = await onFinish(values).then((response: any) => {
            if (response) {
              if (!saveAsDraft) {
                sendEmail(mail_arr)
                mutate({
                  resource: 'notifications',
                  values: notification_arr,
                })
              }

              setDisableSaveBtn(false)
              close()
              updatePercentage()
            }
          })

          return response
        }}
      >
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item
              label="Work Request Name"
              name="name"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={16}>
            <Form.Item label="Description" name="description">
              <Input disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Request Type" name="request_type" initialValue={'Q'} rules={[{ required: true }]}>
              <Select
                allowClear
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
                onChange={handleRequestType}
                options={[
                  { label: 'Question', value: 'Q' },
                  { label: 'Variant', value: 'V' },
                  { label: 'Parent Child', value: 'PC' },
                ]}
              />
            </Form.Item>
          </Col>
          {record?.paper_wr_type ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Paper Request Type" name="paper_wr_type" initialValue={'Bulk'} rules={[{ required: true }]}>
                <Select
                  disabled
                  options={[
                    { label: 'Bulk', value: 'Bulk' },
                    { label: 'Urgent', value: 'Urgent' },
                  ]}
                />
              </Form.Item>
            </Col>
          ) : null}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Status" name="status" initialValue={'Open'} rules={[{ required: true }]}>
              <Select {...workrequestStatusSelectProps} />
            </Form.Item>
          </Col> */}
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Question Type" name="question_type_id" rules={[{ required: validation?.question_type_id }]}>
              <Select
                allowClear
                {...questionTypeSelectProps}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              />
            </Form.Item>
          </Col> */}
          <Col xs={24} lg={8}>
            <Form.Item
              label="Due Date"
              name="due_date"
              rules={[{ required: false }]}
              getValueProps={value => ({
                value: value ? dayjs(value) : '',
              })}
            >
              <DatePicker
                style={{ width: '100%' }}
                disabledDate={disabledDate}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              />
            </Form.Item>
          </Col>

          <Col xs={24} lg={8}>
            <Form.Item label="Grade" name="grade_ids" rules={[{ required: false }]}>
              <Select
                {...gradeSelectProps}
                mode="multiple"
                allowClear
                showSearch={false}
                filterOption={false}
                defaultActiveFirstOption={true}
                defaultValue={gradeDefaultValue?.length > 0 ? gradeDefaultValue : []}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={24} lg={8}>
            <Form.Item label="Subject" name="subject_id" rules={[{ required: validation?.subject_id }]}>
              <Select
                allowClear
                {...subjectSelectProps}
                onChange={handleSubjectChange}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              />
            </Form.Item>
          </Col>

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Report Theme (TN_Term_Month)" name="report_theme_id" rules={[{ required: false }]}>
              <Select
                // disabled={
                //   formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false
                // }
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  record?.paper_wr_type ||
                  (formProps?.form?.getFieldValue('subject_id') === undefined || formProps?.form?.getFieldValue('subject_id') == null ? true : false)
                }
                showSearch
                allowClear
                // filterOption={(input: any, option: any) =>
                //   option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                //   option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                // }
                {...reportThemeSelectProps}
                onChange={handleReportThemeChange}
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} lg={8}>
            <Form.Item label="Theme" name="theme_id" rules={[{ required: false }]}>
              <Select
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={handleThemeChange}
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  record?.paper_wr_type ||
                  (formProps?.form?.getFieldValue('subject_id') === undefined || formProps?.form?.getFieldValue('subject_id') == null ? true : false)
                }
              >
                {themeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Sub Theme" name="sub_theme_id" rules={[{ required: false }]}>
              <Select
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                onChange={handleSubThemeChange}
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  record?.paper_wr_type ||
                  (formProps?.form?.getFieldValue('theme_id') === undefined || formProps?.form?.getFieldValue('theme_id') == null ? true : false)
                }
              >
                {subThemeResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Topic" name="topic_id" rules={[{ required: false }]}>
              {/* <TopicSelector /> */}
              {/* <Select {...topicSelectProps} /> */}
              <Select
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  record?.paper_wr_type ||
                  (formProps?.form?.getFieldValue('sub_theme_id') === undefined || formProps?.form?.getFieldValue('sub_theme_id') == null
                    ? true
                    : false)
                }
              >
                {tableQueryResult?.data?.data?.map(item => (
                  <option key={item.id} value={item.id}>
                    {item.name}
                  </option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          {requestType === 'Q' ? (
            <Col xs={24} lg={8}>
              <Form.Item
                label="Number of questions (Fill in with either 9 or 25)"
                name="count"
                initialValue={questionCount}
                rules={[{ required: true }]}
              >
                <Input onChange={e => setQuestionCount(parseInt(e.target.value))} disabled={record?.paper_wr_type} />
              </Form.Item>
            </Col>
          ) : null}
        </Row>
        <Row gutter={[16, 0]}>
          {requestType === 'Q' || requestType === 'PC' ? (
            <Col xs={24} lg={8}>
              <Form.Item label="Choose the creator's name" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onSearch={value => searchUser('qcreator', value)}
                  // filterOption={false}
                  onChange={() => setResetCreatorData(true)}
                  disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
                >
                  {qcreatorList?.length > 0 &&
                    qcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
              </Form.Item>
            </Col>
          ) : (
            <Col xs={24} lg={8}>
              <Form.Item label="Variant Creator" name="creator_id" rules={[{ required: validation?.creator_id }]}>
                <Select
                  onChange={() => setResetVCreatorData(true)}
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                  // onSearch={value => searchUser('variantcreator', value)}
                  // filterOption={false}
                  disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
                >
                  {vcreatorList?.length > 0 &&
                    vcreatorList?.map(item => (
                      <option key={item?.id} value={item?.id}>
                        {item?.displayName}
                      </option>
                    ))}
                </Select>
                {/* <Select />{" "} */}
              </Form.Item>
            </Col>
          )}
          <Col xs={24} lg={8}>
            <Form.Item
              label="Choose the reviewer's name (if known)"
              name="reviewer_ids"
              rules={[{ required: false }]}
              // initialValue={selectedReviewerIds}
              initialValue={record?.reviewer_ids}
            >
              {/* {console.log({ allReviewers })} */}
              <Select
                mode="multiple"
                allowClear
                showSearch
                filterOption={(input: any, option: any) =>
                  option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                  option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                // onSearch={value => searchUser('qreviewer', value)}
                // filterOption={false}
                onChange={(value: any) => reviewerChange(value)}
                defaultValue={selectedReviewerIds}
                disabled={record?.reviewer_ids?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
              >
                {qreviewerList?.length > 0 &&
                  qreviewerList?.map(item => (
                    <option key={item?.id} value={item?.id}>
                      {item?.displayName}
                    </option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          {/* {console.log({allReviewers})} */}
          <Col xs={24} lg={24}>
            {showApprover
              ? allReviewers?.length > 0 &&
                allReviewers.map((elem: any, i: any) => (
                  <Row
                    key={i}
                    gutter={[16, 0]}
                    style={{ display: selectedReviewerIds?.length > 0 && !selectedReviewerIds.includes(elem?.reviewer?.id) ? 'none' : 'flex' }}
                  >
                    <Col xs={24} lg={12}>
                      <Form.Item
                        label="Reviewer"
                        name={'reviwer_id_selected_' + i}
                        rules={[
                          {
                            required: false,
                            message: 'Select a Reviewer',
                          },
                        ]}
                      >
                        <Input
                          disabled={record?.reviewer_ids?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
                          placeholder={elem?.reviewer?.displayName}
                          defaultValue={elem?.reviewer?.displayName}
                          readOnly
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} lg={8}>
                      <Form.Item
                        label="Choose the approver's name (if known)"
                        name={'approver_ids_' + i}
                        rules={[{ required: false, message: 'Select an Approver' }]}
                      >
                        {elem?.ap_ids?.length > 0 ? (
                          <>
                            <Select
                              allowClear
                              showSearch
                              filterOption={(input: any, option: any) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                              // onSearch={value => searchUser('qapprover', value)}
                              // filterOption={false}
                              mode="multiple"
                              defaultValue={elem?.ap_ids}
                              onChange={(value: any) => changeApprover(value, elem?.reviewer?.id)}
                              disabled={
                                elem?.status !== 'new' &&
                                elem?.ap_ids?.length > 0 &&
                                (record?.status === 'In Progress' || record?.status === 'Closed')
                              }
                            >
                              {qapproverList?.length > 0 &&
                                qapproverList?.map(item => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.displayName}
                                  </option>
                                ))}
                            </Select>
                          </>
                        ) : (
                          <Select
                            allowClear
                            showSearch
                            filterOption={(input: any, option: any) =>
                              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                              option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                            // onSearch={value => searchUser('qapprover', value)}
                            // filterOption={false}
                            mode="multiple"
                            disabled={elem?.approver_ids?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
                            defaultValue={elem?.ap_ids}
                            onChange={(value: any) => changeApprover(value, elem?.reviewer?.id)}
                          >
                            {qapproverList?.length > 0 &&
                              qapproverList?.map(item => (
                                <option key={item?.id} value={item?.id}>
                                  {item?.displayName}
                                </option>
                              ))}
                          </Select>
                        )}
                      </Form.Item>
                    </Col>
                  </Row>
                ))
              : null}
            <Form.Item>
              <Button
                disabled={record?.workRequestApprovers?.length > 0 && (record?.status === 'In Progress' || record?.status === 'Closed')}
                type="dashed"
                onClick={() => addApprover()}
                block
                icon={<PlusOutlined />}
              >
                Add Approver
              </Button>
            </Form.Item>
          </Col>

          <Col xs={24} lg={24}>
            <Button
              type="dashed"
              onClick={() => setShowChangeUserSection(!showChangeUserSection)}
              hidden={record?.status === 'Open' || (userRole !== 'admin' && userRole !== 'subjectincharge')}
              style={{ width: '100%' }}
              icon={<PlusOutlined />}
            >
              Change Users
            </Button>
          </Col>
        </Row>

        {/* {console.log({ currentCreator })} */}
        <Row gutter={[16, 0]} hidden={!showChangeUserSection} style={{ display: 'flex', alignItems: 'end' }}>
          <Spin spinning={loadNewUsers} />
          <>
            <Col xs={24} lg={12}>
              <Form.Item
                label="Creator"
                name={'old_creator_id'}
                rules={[
                  {
                    required: false,
                    // message: 'Select a Reviewer',
                  },
                ]}
                initialValue={currentCreator?.displayName}
              >
                <Input
                  value={currentCreator?.displayName}
                  placeholder={currentCreator?.displayName}
                  defaultValue={currentCreator?.displayName}
                  readOnly
                />
              </Form.Item>
            </Col>
            <Col xs={24} lg={8}>
              <Form.Item label="New User" name={'new_creator_id'} rules={[{ required: false, message: 'Select new creator' }]}>
                <Select
                  allowClear
                  showSearch
                  filterOption={(input: any, option: any) =>
                    option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {qcreatorList?.length > 0 &&
                    qcreatorList?.map(
                      item =>
                        item?.id !== currentCreator?.id && (
                          <option key={item?.id} value={item?.id}>
                            {item?.displayName}
                          </option>
                        )
                    )}
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} lg={4}>
              <Form.Item>
                <Button type="primary" onClick={() => changeCreatorUser(currentCreator?.id)}>
                  Change
                </Button>
              </Form.Item>
            </Col>
          </>
          {/* {console.log("data",selectedReviewerIds)} */}

          {allReviewers?.length > 0 &&
            allReviewers.map((elem: any, i: any) =>
              selectedReviewerIds?.includes(elem?.reviewer?.id) === true ? (
                <>
                  <Col xs={24} lg={12}>
                    <Form.Item
                      label="Reviewer"
                      name={'old_reviewer_id_' + i}
                      rules={[
                        {
                          required: false,
                          message: 'Select a Reviewer',
                        },
                      ]}
                      // initialValue={elem?.reviewer?.id}
                    >
                      <Input
                        // value={elem?.reviewer?.id}
                        placeholder={elem?.reviewer?.displayName}
                        defaultValue={elem?.reviewer?.displayName}
                        readOnly
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={8}>
                    <Form.Item label="New User" name={'new_reviewer_id_' + i} rules={[{ required: false, message: 'Select new reviewer' }]}>
                      <Select
                        allowClear
                        showSearch
                        filterOption={(input: any, option: any) =>
                          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                          option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {qreviewerList?.length > 0 &&
                          qreviewerList?.map(item =>
                            item?.id !== elem?.reviewer?.id ? (
                              <option key={item?.id} value={item?.id}>
                                {item?.displayName}
                              </option>
                            ) : null
                          )}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xs={24} lg={3}>
                    <Form.Item>
                      <Button type="primary" onClick={() => changeReviewerUsers(elem?.reviewer?.id, i)}>
                        Change
                      </Button>
                    </Form.Item>
                  </Col>
                  {selectedReviewerIds?.length > 1 ? (
                    <Col xs={24} lg={1}>
                      <Form.Item>
                        <Button
                          type="primary"
                          icon={<Icons.DeleteOutlined />}
                          danger
                          onClick={() =>
                            deleteReviewer(elem?.reviewer?.id).then((resp: any) => {
                              setDeleteApproverLoader(false)
                              if (resp?.data?.id) {
                                showMessage('success')
                              } else {
                                showMessage('error')
                              }
                            })
                          }
                        />
                      </Form.Item>
                    </Col>
                  ) : null}
                  {/* </Form> */}
                  {elem?.approver_ids?.length > 0 &&
                    elem?.approver_ids?.map((approver: any, index: any) => (
                      <>
                        {/* <Form> */}
                        <Col xs={24} lg={12}>
                          <Form.Item
                            label="Approver"
                            name={'old_approver_id_' + index}
                            rules={[
                              {
                                required: false,
                                message: 'Select a Approver',
                              },
                            ]}
                          >
                            <Input placeholder={approver?.displayName} defaultValue={approver?.displayName} readOnly />
                          </Form.Item>
                        </Col>
                        <Col xs={24} lg={8}>
                          <Form.Item label="New User" name={'new_approver_id_' + index} rules={[{ required: false, message: 'Select new reviewer' }]}>
                            <Select
                              allowClear
                              showSearch
                              filterOption={(input: any, option: any) =>
                                option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                                option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {qapproverList?.length > 0 &&
                                qapproverList?.map(item =>
                                  item?.id !== approver?.id ? (
                                    <option key={item?.id} value={item?.id}>
                                      {item?.displayName}
                                    </option>
                                  ) : null
                                )}
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col xs={24} lg={3}>
                          <Form.Item>
                            <Button type="primary" onClick={() => changeApproverUsers(approver?.id, index)}>
                              Change
                            </Button>
                          </Form.Item>
                        </Col>
                        {/* {elem?.approver_ids?.length>1?
                      <Col xs={24} lg={1}>
                        <Form.Item>
                        
                           <Button type='primary' icon={<Icons.DeleteOutlined/>} danger onClick={() => deleteApprover(approver,elem).then(()=>{
setDeleteApproverLoader(false)
updateQuestions("approver_id",approver?.id,newApproverId).then(()=>{updatePercentage();newApproverId=""})
                           })} />
                        </Form.Item> 
                      </Col>:null} */}
                        {/* </Form> */}
                      </>
                    ))}
                </>
              ) : null
            )}
        </Row>
        <Spin spinning={deleteApproverLoader} tip="Deleting..." />
        <Row gutter={[16, 0]}>
          {/* // :
          // null} */}

          <Col xs={24} lg={24}>
            <Divider orientation="left" orientationMargin="0" className="primary">
              Tags
            </Divider>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Competency" name="competency_id" rules={[{ required: false }]}>
              <Select
                allowClear
                onChange={handleCompetencyChange}
                {...competencySelectProps}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Taxonomy" name="taxonomy_id" rules={[{ required: false }]}>
              <Select
                allowClear
                onChange={handleTaxonomyChange}
                {...tntaxonomySelectProps}
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  formProps?.form?.getFieldValue('competency_id') === undefined ||
                  formProps?.form?.getFieldValue('competency_id') == null
                }
              />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Standard" name="strand_id" rules={[{ required: false }]}>
              <Select
                allowClear
                {...strandSelectProps}
                disabled={
                  record?.status === 'In Progress' ||
                  record?.status === 'Closed' ||
                  formProps?.form?.getFieldValue('taxonomy_id') === undefined ||
                  formProps?.form?.getFieldValue('taxonomy_id') == null
                }
              />
            </Form.Item>
          </Col>
          {/* <Col xs={24} lg={8}>
            <Form.Item label="Teacher Level" name="teacher_level_id" rules={[{ required: false }]}>
              <Select
                onChange={handleTeacherLevelChange}
                {...teacherlevelSelectProps}
                disabled={record?.status === 'In Progress' || record?.status === 'Closed'}
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate Bloom's taxonomy level" name="bloom_level_id" rules={[{ required: false }]}>
              <Select allowClear {...bloomlevelSelectProps} disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col>
          <Col xs={24} lg={8}>
            <Form.Item label="Choose the appropriate difficulty level" name="difficulty_level_id" rules={[{ required: false }]}>
              <Select allowClear {...difficultylevelSelectProps} disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col>

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Question" name="question_id" rules={[{ required: false }]}>
              <Select />
            </Form.Item>
          </Col> */}

          {/* <Col xs={24} lg={8}>
            <Form.Item label="Report Theme" name="report_theme_id" rules={[{ required: false }]}>
              <Select {...reportThemeProps} disabled={record?.status === 'In Progress' || record?.status === 'Closed'} />
            </Form.Item>
          </Col> */}
          {requestType === 'V' ? (
            <>
              <Col xs={24} lg={24}>
                <Divider orientation="left" orientationMargin="0" className="primary">
                  Add Variants
                </Divider>
              </Col>
              <Col xs={24} lg={24}>
                <Form.List name="variant_options">
                  {(fields, { add, remove }) => (
                    <>
                      {fields.map(({ key, name, ...restField }) => (
                        <Row gutter={[16, 0]}>
                          <Col xs={24} lg={12}>
                            <Form.Item
                              {...restField}
                              label="Variant Question"
                              name={[name, 'question_id']}
                              rules={[
                                {
                                  required: true,
                                  message: 'Missing Variant Question',
                                },
                              ]}
                            >
                              <Select allowClear>
                                {questionResult?.data?.data?.map(item => (
                                  <option key={item?.id} value={item?.id}>
                                    {item?.title}
                                  </option>
                                ))}
                              </Select>
                            </Form.Item>
                          </Col>
                          <Col xs={24} lg={8}>
                            <Form.Item
                              {...restField}
                              label="Variant Count"
                              name={[name, 'variant_count']}
                              rules={[{ required: true, message: 'Missing Count' }]}
                            >
                              <Input placeholder="Variant Count" type="small" />
                            </Form.Item>
                          </Col>
                          <MinusCircleOutlined onClick={() => remove(name)} />
                        </Row>
                        // </Space>
                      ))}
                      <Form.Item>
                        <Button type="dashed" onClick={() => add()} block icon={<PlusOutlined />}>
                          Add Variants
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form.List>
              </Col>
            </>
          ) : null}
          <Form.Item name="updated_by" initialValue={user?.id}>
            <Input type="hidden" />
          </Form.Item>
        </Row>
        <Row gutter={[16, 0]} justify="end" align="top">
          <Spin spinning={disableSaveBtn}></Spin>
          <Col xs={24} lg={8} style={{ display: 'flex', justifyContent: 'end' }}>
            <Space>
              <Button onClick={() => close()}>Cancel</Button>
              <Button type="primary" htmlType="submit" disabled={disableSaveBtn}>
                Submit
              </Button>

              <Button
                className="save-draft-btn"
                htmlType="submit"
                onClick={() => {
                  setValidation({ question_type_id: false, subject_id: false, creator_id: false })
                  setSaveDraft(true)
                }}
                hidden={record?.status === 'In Progress' || record?.status === 'Closed' || record?.paper_wr_type}
              >
                Save Draft
              </Button>
            </Space>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}
